export const sourceLabelName = 'name'
export const dropDownIdEmpty = null
